/* Categoriebalk: pijltjes + vervaging links/rechts, zodat duidelijk is dat er meer categorieën zijn. */
(function () {
  var nav = document.querySelector('nav.cats'); if (!nav) return;
  var rail = nav.querySelector('.rail'); if (!rail) return;
  function bg() {
    var el = nav, c;
    while (el && el !== document.documentElement) { c = getComputedStyle(el).backgroundColor; if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') return c; el = el.parentElement; }
    return '#1a1a1c';
  }
  var col = bg();
  var css = document.createElement('style');
  css.textContent =
    'nav.cats{position:relative}' +
    '.vdn-b{position:absolute;top:0;bottom:0;width:64px;border:0;margin:0;padding:0 12px;color:#fff;font-size:30px;line-height:1;cursor:pointer;display:flex;align-items:center;z-index:5;opacity:0;pointer-events:none;transition:opacity .2s}' +
    '.vdn-b.on{opacity:1;pointer-events:auto}' +
    '.vdn-b span{width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,.16);display:grid;place-items:center;font-size:22px;padding-bottom:3px}' +
    '.vdn-b:hover span{background:var(--accent,#d50029)}' +
    '.vdn-l{justify-content:flex-start;background:linear-gradient(to right,' + col + ' 45%,rgba(0,0,0,0))}' +
    '.vdn-r{justify-content:flex-end;background:linear-gradient(to left,' + col + ' 45%,rgba(0,0,0,0))}';
  document.head.appendChild(css);
  function mk(cls, label, txt) { var b = document.createElement('button'); b.type = 'button'; b.className = 'vdn-b ' + cls; b.setAttribute('aria-label', label); b.innerHTML = '<span>' + txt + '</span>'; nav.appendChild(b); return b; }
  var L = mk('vdn-l', 'Eerdere categorieën', '‹'), R = mk('vdn-r', 'Meer categorieën', '›');
  function upd() {
    var max = rail.scrollWidth - rail.clientWidth, x = rail.scrollLeft;
    var nr = nav.getBoundingClientRect(), rr = rail.getBoundingClientRect();
    L.style.left = Math.max(0, rr.left - nr.left) + 'px';
    R.style.right = Math.max(0, nr.right - rr.right) + 'px';
    L.classList.toggle('on', x > 4);
    R.classList.toggle('on', x < max - 4);
  }
  function go(dir) { rail.scrollBy({ left: dir * Math.max(200, rail.clientWidth * 0.7), behavior: 'smooth' }); }
  L.addEventListener('click', function () { go(-1); });
  R.addEventListener('click', function () { go(1); });
  rail.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd);
  rail.addEventListener('wheel', function (e) {
    var max = rail.scrollWidth - rail.clientWidth;
    if (max <= 0 || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    var nx = rail.scrollLeft + e.deltaY;
    if ((e.deltaY > 0 && rail.scrollLeft < max - 1) || (e.deltaY < 0 && rail.scrollLeft > 0)) { rail.scrollLeft = nx; e.preventDefault(); }
  }, { passive: false });
  var cur = rail.querySelector('[aria-current]');
  if (cur) { var o = cur.offsetLeft - rail.clientWidth / 2 + cur.offsetWidth / 2; if (o > 0) rail.scrollLeft = o; }
  upd(); setTimeout(upd, 400); window.addEventListener('load', upd);
})();
